/* tslint:disable */
/* eslint-disable */
/* @relayHash 41b6ac5333ec1823f90eaf55d7f21418 */

import { ConcreteRequest } from "relay-runtime";
export type consumerSourcingTooltipQueryVariables = {
    itemId: string;
};
export type consumerSourcingTooltipQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly pricing: {
                readonly retailPrice: {
                    readonly convertedAmounts: {
                        readonly USD: number | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    };
};
export type consumerSourcingTooltipQuery = {
    readonly response: consumerSourcingTooltipQueryResponse;
    readonly variables: consumerSourcingTooltipQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPricing",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "retailPrice",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmounts",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "USD",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "consumerSourcingTooltipQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "consumerSourcingTooltipQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "consumerSourcingTooltipQuery",
    "id": "ferrum/267.0.0-2020-06-02T15:59:29.433Z/consumerSourcingTooltipQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'df67587006abc4b58a5c511b22a070f0';
export default node;
